/** Theme colors for the Tailwind shades that have no token of their own,
 *  mixed from the tokens in index.css. In the light theme each one lands
 *  within a few RGB steps of the shade pages hard-coded (named alongside), so
 *  the light theme looks the same; in the dark theme it follows the tokens
 *  instead of staying light. Use them where a page had that hex literal. */
export const mix = {
  /** Text between body and muted: #334155 (slate-700) in light. */
  textSecondary: 'color-mix(in srgb, var(--color-text-muted) 48%, var(--color-text))',
  /** Text a step above muted: #475569 (slate-600) in light. */
  textTertiary: 'color-mix(in srgb, var(--color-text-muted) 68%, var(--color-text))',
  /** Near-body text: #1E293B (slate-800) in light. */
  textStrong: 'color-mix(in srgb, var(--color-text-muted) 25%, var(--color-text))',
  /** Soft fill and hairline: #F1F5F9 (slate-100) in light. */
  fillSoft: 'color-mix(in srgb, var(--color-border) 50%, var(--color-surface))',
  /** Chip and banner fills a step stronger than the -dim tokens. */
  greenSoft: 'color-mix(in srgb, var(--color-status-green-border) 25%, var(--color-surface))', // #DCFCE7
  redSoft: 'color-mix(in srgb, var(--color-status-red-border) 55%, var(--color-surface))', // #FEE2E2
  warnSoft: 'color-mix(in srgb, var(--color-warn-border) 50%, var(--color-surface))', // #FEF3C7
  blueSoft: 'color-mix(in srgb, var(--color-interactive-border) 55%, var(--color-surface))', // #DBEAFE
  brandSoft: 'color-mix(in srgb, var(--color-brand-dim) 60%, var(--color-surface))', // #F5F3FF
  brandFaint: 'color-mix(in srgb, var(--color-brand-dim) 40%, var(--color-surface))', // #FAF5FF
} as const;
